// element-ui table props
export const ElTableProps = {
  // Table 的尺寸 => medium / small / mini
  size: String,

  width: [String, Number],

  // Table 的高度，默认为自动高度。
  // 如果 height 为 number 类型，单位 px；
  // 如果 height 为 string 类型，则这个高度会设置为 Table 的 style.height 的值，Table 的高度会受控于外部样式。
  height: [String, Number],

  // Table 的最大高度。合法的值为数字或者单位为 px 的高度。
  maxHeight: [String, Number],

  // 列的宽度是否自撑开
  fit: {
    type: Boolean,
    default: true
  },

  // 是否为斑马纹 table
  stripe: Boolean,

  // 是否带有纵向边框
  border: Boolean,

  // 行数据的 Key，用来优化 Table 的渲染；在使用 reserve-selection 功能与显示树形数据时，该属性是必填的。
  // 类型为 String 时，支持多层访问：user.info.id，但不支持 user.info[0].id，此种情况请使用 Function => Function(row)
  rowKey: [String, Function],

  context: {},

  // 是否显示表头
  showHeader: {
    type: Boolean,
    default: true
  },

  // 是否在表尾显示合计行
  showSummary: Boolean,

  // 合计行第一列的文本
  sumText: String,

  // 自定义的合计计算方法 => Function({ columns, data })
  summaryMethod: Function,

  // 行的 className 的回调方法 => Function({ row, rowIndex })
  // 也可以使用字符串为所有行设置一个固定的 className
  rowClassName: [String, Function],

  // 行的 style 的回调方法 => Function({row, rowIndex})
  // 也可以使用一个固定的 Object 为所有行设置一样的 Style。
  rowStyle: [Object, Function],

  // 单元格的 className 的回调方法 => Function({row, column, rowIndex, columnIndex})
  // 也可以使用字符串为所有单元格设置一个固定的 className
  cellClassName: [String, Function],

  // 单元格的 style 的回调方法 => Function({row, column, rowIndex, columnIndex})
  // 也可以使用一个固定的 Object 为所有单元格设置一样的 Style。
  cellStyle: [Object, Function],

  // 表头行的 className 的回调方法 => Function({row, rowIndex})
  // 也可以使用字符串为所有表头行设置一个固定的 className
  headerRowClassName: [String, Function],

  // 表头行的 style 的回调方法 => Function({row, rowIndex})
  // 也可以使用一个固定的 Object 为所有表头行设置一样的 Style
  headerRowStyle: [Object, Function],

  // 表头单元格的 className 的回调方法 => Function({row, column, rowIndex, columnIndex})
  // 也可以使用字符串为所有表头单元格设置一个固定的 className。
  headerCellClassName: [String, Function],

  // 表头单元格的 style 的回调方法 => Function({row, column, rowIndex, columnIndex})
  // 也可以使用一个固定的 Object 为所有表头单元格设置一样的 Style。
  headerCellStyle: [Object, Function],

  // 是否要高亮当前行
  highlightCurrentRow: Boolean,

  // 当前行的 key，只写属性
  currentRowKey: [String, Number],

  // 空数据时显示的文本内容，也可以通过 slot="empty" 设置
  emptyText: String,

  // 可以通过该属性设置 Table 目前的展开行，需要设置 row-key 属性才能使用，该属性为展开行的 keys 数组
  expandRowKeys: Array,

  // 是否默认展开所有行，当 Table 包含展开行存在或者为树形表格时有效
  defaultExpandAll: Boolean,

  // 默认的排序列的 prop 和顺序。
  // 它的prop属性指定默认的排序的列，order指定默认排序的顺序 => {prop, order: ascending / descending}
  defaultSort: Object,

  // tooltip effect 属性 => dark/light
  tooltipEffect: String,

  // 合并行或列的计算方法 => Function({ row, column, rowIndex, columnIndex })
  spanMethod: Function,

  // 在多选表格中，当仅有部分行被选中时，点击表头的多选框时的行为。若为 true，则选中所有行；若为 false，则取消选择所有行
  selectOnIndeterminate: {
    type: Boolean,
    default: true
  },

  // 展示树形数据时，树节点的缩进
  indent: {
    type: Number,
    default: 16
  },

  // 渲染嵌套数据的配置选项 => { hasChildren: 'hasChildren', children: 'children' }
  treeProps: {
    type: Object,
    default() {
      return {
        hasChildren: "hasChildren",
        children: "children"
      };
    }
  },

  // 是否懒加载子节点数据
  lazy: Boolean,

  // 加载子节点数据的函数，lazy 为 true 时生效，函数第二个参数包含了节点的层级信息 => Function(row, treeNode, resolve)
  load: Function
};
